export function formatValue(inputValue: any, addNairaSymbol = true) {
  const nairaSymbol = "₦";
  if (!inputValue) return "";
  const numericValue = inputValue.replace(/[^\d]/g, "");
  const formattedValue = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${addNairaSymbol ? nairaSymbol : ""}${formattedValue}`;
}
